import each from "lodash/each";
import router from "@/router";

export default {
  getLanguageList: function ({ commit, rootState }) {
    const _this = this;

    return new Promise((resolve, reject) => {
      commit("REQUEST_LANGUAGE_LIST");
      this._vm.$onesocket.send({
        function: "getActiveLanguages",
        module: "SQMOD_SystemSettings",
        data: {},
        onMessage: function (data) {
          if (data.payload.status === "OK") {
            commit(
              "SUCCESS_REQUEST_LANGUAGE_LIST",
              data.payload.root.languages
            );

            each(data.payload.root.languages, (item) => {
              if (item.lang_key === _this._vm.$cookies.get("lang-key")) {
                commit("SET_SELECTED_LANGUAGE", item);
                return false;
              } else if (
                item.lang_key === rootState.session.browserLang ||
                item.lang_key === rootState.session.browserLang.substring(0, 2)
              ) {
                commit("SET_SELECTED_LANGUAGE", item);
              }
            });

            resolve();
          } else {
            commit("FAILURE_REQUEST_LANGUAGE_LIST");
            _this._vm.$logger.error(
              "language-store",
              "Invalid response from getActiveLanguages"
            );
            reject();
          }
        },
        onError: function (error) {
          commit("FAILURE_REQUEST_LANGUAGE_LIST");
          _this._vm.$logger.error(
            "language-store",
            "Failed to fetch getActiveLanguages",
            error
          );
        },
      });
    });
  },
  /**
   * Handles and sets language for the whole app.
   *
   * Language selection priority:
   *  1. Language Cookie
   *  2. Browser Language
   *  3. Profile Language
   *  4. URL language query
   *  5. Fallback language (en)
   *
   */
  async setLanguage(
    { state, commit, dispatch, rootState },
    { room, lang_key }
  ) {
    if (!lang_key && state.setLanguageStatus === "fetching") {
      // If no lang_key given and currently an automatic language will be set, abort request.
      return;
    }

    commit("REQUEST_LANGUAGE");
    if (!lang_key) {
      if (this._vm.$cookies.get("lang-key")) {
        lang_key = this._vm.$cookies.get("lang-key");
      } else if (rootState.session.browserLang) {
        lang_key = rootState.session.browserLang;
      } else if (rootState.session.authResult.language.lang_key) {
        lang_key = rootState.session.authResult.language.lang_key;
      } else if (router.currentRoute.query.lang.toLowerCase()) {
        lang_key = router.currentRoute.query.lang.toLowerCase();
      } else {
        lang_key = this._vm.$config.fallbackLanguageKey;
      }
    }

    const _this = this;

    if (rootState.language.key === lang_key) {
      return;
    }

    try {
      if (rootState.language.languageList.length < 1) {
        await dispatch("getLanguageList");
      }

      const languageByLangKey = rootState.language.languageList.filter(
        (item) => {
          return item.lang_key.toLowerCase() === lang_key.toLowerCase();
        }
      );

      // If language not supported, fallback
      if (!languageByLangKey || languageByLangKey.length < 1) {
        lang_key = this._vm.$config.fallbackLanguageKey;
      }

      try {
        Kommunicate.updateUserLanguage(lang_key);
      } catch (error) {}

      this._vm.$cookies.set("lang-key", lang_key);
      // Asynchronous call ahead, must set language in config beforehand
      this._vm.$config.language_key = lang_key.toUpperCase();

      this._vm.$onesocket.send({
        function: "setLanguageOfRoom",
        module: "SQMOD_SystemSettings",
        data: {
          room: room,
          language: languageByLangKey[0].language,
        },
        onMessage: function (data) {
          if (data.payload.status === "OK") {
            commit("SUCCESS_SET_LANGUAGE", lang_key.toLowerCase());
            dispatch("weather/loadWeatherData", {}, { root: true });
            if (
              router.currentRoute &&
              router.currentRoute.name !== "login" &&
              rootState.language.selectedLanguage != null &&
              rootState.language.selectedLanguage.lang_key !== lang_key
            ) {
              commit("contentpage/RESET", null, { root: true });
              dispatch("session/reAuthenticate", null, { root: true });
            }
          } else {
            commit("FAILURE_SET_LANGUAGE", lang_key.toLowerCase());
            _this._vm.$logger.error(
              "language-store",
              "Invalid response from setLanguageOfRoom"
            );
            if (languageByLangKey && languageByLangKey.length > 0) {
              commit("SET_SELECTED_LANGUAGE", languageByLangKey[0]);
            }
          }
        },
        onError: function (error) {
          commit("FAILURE_SET_LANGUAGE", lang_key.toLowerCase());
          _this._vm.$logger.error(
            "language-store",
            "Failed to fetch setLanguageOfRoom",
            error
          );
        },
      });
    } catch (error) {
      console.error(error.message);
    }
  },
  deleteCookies() {
    this._vm.$cookies.remove("lang-key");
  },
};
